import React from 'react';
import {t} from '@lingui/core/macro';

import {ITariff} from 'entities/tariff';

import AdminFormModal, {IAdminEntityModalProps} from '../AdminList/AdminFormModal';
import TariffForm from './TariffForm/TariffForm';

const TariffModal: React.FC<IAdminEntityModalProps<ITariff>> = (props) => (
    <AdminFormModal {...props} addHeader={t`Добавить тариф`} editHeader={t`Изменить тариф`} Form={TariffForm}/>
);

export default TariffModal;
